import { DynamicForm, useApiService, validators, withFormService } from "@art/shared-ui";

function ArtUserAddPage({ data, onInit, onSave }: any) {
    const apiService = useApiService();

    const formBuilder = (data: any) => {
        return [
            ...(!data?.id ? [
                {
                    type: "row",
                    children: [
                        {
                            type: "col",
                            classNames: ["col-12"],
                            children: [
                                {
                                    id: "username",
                                    label: "Username",
                                    type: "text",
                                    placeholder: "Enter your Username",
                                    required: true,
                                    dataQa: "artusername",
                                    value: data?.username || "",
                                    validate: validators((value) => {
                                        if (!value || value.trim() === "") {
                                            return "Username is required.";
                                        }
                                        if (value !== value.trimStart()) {
                                            return "Username cannot start with spaces.";
                                        }
                                        if (value.trim().length < 3) {
                                            return "Username must be at least 3 characters long.";
                                        }
                                        if (value.trim().length > 50) {
                                            return "Username must not exceed 50 characters.";
                                        }
                                        // if (/[^a-zA-Z\s]/.test(value)) {
                                        //     return "Username must only contain letters and spaces.";
                                        // }
                                        return null;
                                    }),
                                },
                            ],
                        },
                    ],
                }] : [
                {
                    type: "hidden",
                    id: "username",
                    value: data?.username
                }
            ]),
            {
                type: "row",
                children: [
                    {
                        type: "col",
                        classNames: ["col-12"],
                        children: [
                            {
                                id: "first_name",
                                label: "First Name",
                                type: "text",
                                placeholder: "Enter your First Name",
                                required: true,
                                dataQa: "artfirstname",
                                value: data?.first_name || "",
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "First Name is required.";
                                    }
                                    if (value !== value.trimStart()) {
                                        return "First Name cannot start with spaces.";
                                    }

                                    if (value.trim().length < 3) {
                                        return "First Name must be at least 3 characters long.";
                                    }
                                    if (value.trim().length > 50) {
                                        return "First Name must not exceed 50 characters.";
                                    }
                                    if (/[^a-zA-Z\s]/.test(value)) {
                                        return "First name must only contain letters and spaces.";
                                    }
                                    return null;
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                type: "row",
                children: [
                    {
                        type: "col",
                        classNames: ["col-12"],
                        children: [
                            {
                                id: "last_name",
                                label: "Last Name",
                                type: "text",
                                placeholder: "Enter your Last Name",
                                required: true,
                                dataQa: "artlastname",
                                value: data?.last_name || "",
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "Last Name is required.";
                                    }
                                    if (value !== value.trimStart()) {
                                        return "Last Name cannot start with spaces.";
                                    }

                                    if (value.trim().length < 2) {
                                        return "Last Name must be at least 2 characters long.";
                                    }
                                    if (value.trim().length > 20) {
                                        return "Last Name must not exceed 20 characters.";
                                    }
                                    if (/[^a-zA-Z\s]/.test(value)) {
                                        return "Last name must only contain letters and spaces.";
                                    }
                                    return null;
                                }),
                            },
                        ],
                    },
                ],
            },
               {
                type: "row",
                children: [
                    {
                        type: "col",
                        classNames: ["col-12"],
                        children: [
                            {
                                id: "email",
                                label: "Email",
                                type: "text",
                                placeholder: "Enter your Email",
                                required: true,
                                dataQa: "artemail",
                                value: data?.email || "",
                                marginBottom: "0px",
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "Email is required.";
                                    }
                                    if (value !== value.trimStart()) {
                                        return "Email cannot start with spaces.";
                                    }
                                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                        return "Email must be a valid email address.";
                                    }

                                    if (value.trim().length < 2) {
                                        return "Email must be at least 2 characters long.";
                                    }
                                
                                    return null;
                                }),
                            },
                        ],
                    },
                ],
            },
        ];
    };

    return (
        <DynamicForm
            formBuilder={formBuilder}
            onInit={onInit}
            onSubmit={!data ? apiService.saveData("/art-users", 'post', {
                onApiCall: (formData: any) => {
                    return {
                        username: formData.username,
                        first_name: formData.first_name,
                        last_name: formData.last_name,
                        email: formData.email
                    };
                },
                onSuccess: (_res: any) => {
                    onSave();
                },
                onError: (err: any) => {
                    console.log("Error Creating User", err);
                }
            }) : apiService.saveData(`/art-users/${data?.id}`, 'put', {
                onApiCall: (formData: any) => {
                    return {
                        username: formData.username,
                        first_name: formData.first_name,
                        last_name: formData.last_name,
                        email: formData.email

                    };
                },
                onSuccess: (_res: any) => {
                    onSave();
                },
                onError: (err: any) => {
                    console.log("Error Updating User", err);
                }
            })}
        />
    );
}

export default withFormService(ArtUserAddPage);